import {NEW_COLOR_INDEX} from '../utils/constants';
import {initialState} from '../reducers'


const colorIndexReducer = (prevState, action) => {
  //console.log('#RDC-filteredEntryID');
  switch (action.type) {
    case NEW_COLOR_INDEX:
      return action.colorIndex
    default:
    if (prevState) {return prevState}
    else {return initialState.colorIndex}
  }
}

export default colorIndexReducer
//



// WEBPACK FOOTER //
// ./src/reducers/reducer-colorIndexReducer.js